import React, { useState, FC } from 'react';
import { usePopper } from 'react-popper';
import useClickOutside from '../hooks/useClickOutside';
import { PopperWrapper, PopoverArrow } from './popover.style';
import { PopperComponentProps } from './popover.types';

const PopperComponent: FC<PopperComponentProps> = ({
  showArrow = true,
  theme,
  referenceElement,
  popoverOffset,
  preventOverflow = true,
  overflowOverReference = false,
  preventOverflowPadding,
  flipPopover = true,
  placement,
  popoverContent,
  className,
  clickOutsidePopperHandler,
  popperClickHandler,
}: PopperComponentProps) => {
  if (!referenceElement) {
    return null;
  }

  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);
  const [arrowElement, setArrowElement] = useState<HTMLElement | null>(null);
  const options = {
    placement,
    modifiers: [
      {
        name: 'arrow',
        options: {
          element: arrowElement,
        },
      },
      {
        name: 'offset',
        options: {
          offset: popoverOffset,
        },
      },
      {
        name: 'preventOverflow',
        options: {
          mainAxis: preventOverflow,
          altAxis: overflowOverReference,
          padding: preventOverflowPadding,
        },
      },
      {
        name: 'flip',
        options: {
          flipVariations: flipPopover,
        },
      },
    ],
  };

  useClickOutside([popperElement, referenceElement], clickOutsidePopperHandler);
  const { styles, attributes } = usePopper(referenceElement, popperElement, options);

  return (
    <PopperWrapper
      className={className}
      style={styles.popper}
      {...attributes.popper}
      ref={setPopperElement}
      onClick={popperClickHandler}
    >
      {showArrow && (
        <PopoverArrow
          theme={theme}
          ref={setArrowElement}
          arrowStyles={styles.arrow}
          popperPosition={attributes.popper ? attributes.popper['data-popper-placement'] : null}
        />
      )}
      {popoverContent}
    </PopperWrapper>
  );
};

export default PopperComponent;
